import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "warehouse-form" }
const _hoisted_2 = {
  class: "card",
  style: {"max-width":"900px"}
}
const _hoisted_3 = {
  class: "grid",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(220px, 1fr))","gap":"14px"}
}
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = { class: "input-field" }
const _hoisted_8 = { class: "input-field collaborator-field" }
const _hoisted_9 = {
  key: 0,
  class: "dropdown-panel"
}
const _hoisted_10 = { class: "user-list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "hint"
}
const _hoisted_13 = {
  key: 0,
  class: "subtitle",
  style: {"color":"#a54b2a"}
}
const _hoisted_14 = { class: "actions" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "form-grid",
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.provideEquipment && _ctx.provideEquipment(...args)), ["prevent"]))
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", {
              class: "title",
              style: {"font-size":"22px"}
            }, "Fornecer equipamento"),
            _createElementVNode("p", { class: "subtitle" }, "Registre a saida de ferramenta para um colaborador.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "provide-item" }, "Ferramenta / peca", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "provide-item",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.itemId) = $event))
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("option", { value: "" }, "Selecione ferramenta/peca", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.name) + " (disp: " + _toDisplayString(item.availableQuantity) + ") ", 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.itemId]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "provide-quantity" }, "Quantidade", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "provide-quantity",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.quantity) = $event)),
              type: "number",
              min: "1"
            }, null, 512), [
              [
                _vModelText,
                _ctx.form.quantity,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "provide-condition" }, "Estado na saida", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "provide-condition",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.conditionStatus) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.form.conditionStatus]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[11] || (_cache[11] = _createElementVNode("label", null, "Colaborador", -1)),
          _createElementVNode("button", {
            class: "select-trigger",
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
          }, _toDisplayString(_ctx.selectedCollaboratorLabel || 'Selecionar colaborador'), 1),
          (_ctx.isDropdownOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.collaboratorQuery) = $event)),
                  class: "dropdown-search",
                  type: "text",
                  placeholder: "Buscar colaborador"
                }, null, 512), [
                  [_vModelText, _ctx.collaboratorQuery]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCollaborators, (user) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: user.username,
                      class: "user-option",
                      type: "button",
                      onClick: ($event: any) => (_ctx.selectCollaborator(user.username))
                    }, _toDisplayString(user.name) + " (" + _toDisplayString(user.username) + ") ", 9, _hoisted_11))
                  }), 128)),
                  (_ctx.filteredCollaborators.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Nenhum colaborador encontrado."))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "submit",
            disabled: _ctx.saving
          }, _toDisplayString(_ctx.saving ? 'Fornecendo...' : 'Fornecer equipamento'), 9, _hoisted_15),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            disabled: _ctx.saving,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, "Cancelar", 8, _hoisted_16)
        ])
      ], 32)
    ])
  ]))
}